import { useState, useEffect } from 'react';
import brandingService from '../services/brandingService';

export const useBranding = () => {
  const [settings, setSettings] = useState(brandingService.getSettings());

  useEffect(() => {
    const unsubscribe = brandingService.subscribe(setSettings);
    return unsubscribe;
  }, []);

  const updateBranding = (newSettings) => {
    brandingService.updateSettings(newSettings);
  };

  return {
    ...settings,
    updateBranding,
    primaryColor: settings.primaryColor,
    secondaryColor: settings.secondaryColor,
    storeLogo: settings.storeLogo,
    shopName: settings.shopName,
    bannerText: settings.bannerText || '',
    storeId: settings.storeId || null,
    heroImages: settings.heroSectionImages,
    heroContent: settings.heroSectionContent || {},
    heroFromBackend: settings.heroFromBackend || false,
    brandingLoaded: settings.backendLoaded || false,
    backendUnreachable: settings.backendUnreachable || false,
    loginImages: settings.loginPageImages
  };
};
